module.exports = ".textDec {\n  text-decoration: none; }\n\n.mouseover {\n  cursor: pointer; }\n\n.mat-form-field {\n  width: 200px; }\n"